import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";

export default function Register() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/register", { name, email, password });
      toast.success("Cadastro enviado! Aguarde aprovação do administrador.");
      navigate("/pending", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <Logo className="h-12" />
        </div>
        <Card className="border-slate-200 shadow-sm">
          <CardContent className="p-8">
            <h1 className="text-2xl font-heading font-bold text-slate-900 mb-1">Criar Conta</h1>
            <p className="text-sm text-slate-500 mb-6">
              Após o cadastro, um administrador irá aprovar seu acesso.
            </p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="name">Nome completo</Label>
                <Input
                  id="name" required minLength={2} value={name} onChange={(e) => setName(e.target.value)}
                  data-testid="register-name-input" className="mt-1"
                />
              </div>
              <div>
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  data-testid="register-email-input" className="mt-1"
                />
              </div>
              <div>
                <Label htmlFor="password">Senha (mín. 6 caracteres)</Label>
                <Input
                  id="password" type="password" required minLength={6}
                  value={password} onChange={(e) => setPassword(e.target.value)}
                  data-testid="register-password-input" className="mt-1"
                />
              </div>
              <Button
                type="submit" disabled={loading}
                data-testid="register-submit-button"
                className="w-full bg-[#7CB342] hover:bg-[#558B2F] text-white font-semibold"
              >
                {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
                Cadastrar
              </Button>
            </form>
            <div className="mt-6 text-sm">
              <Link to="/login" className="text-[#FF8A50] hover:underline font-medium" data-testid="link-to-login">
                Já tenho conta
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
